export enum enumDropdownActionMenuMode {
  LIGHT = 'light',
  BLUE = 'blue',
  DEFAULT = 'default',
}
